// src/components/Hero.jsx
import { motion } from "framer-motion";
import FlipWords from "./FlipWords";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-white">
   
      <div className="absolute inset-0 bg-brand-radials" />

      <div className="relative z-10 mx-auto max-w-6xl px-4 pt-20 pb-24 text-center">
        <motion.a
          href="#"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="inline-flex items-center gap-2 rounded-full border border-[rgba(2,6,23,.10)] bg-white px-3 py-1 text-[13px] text-ink-muted"
        >
          ✨ Tecnología que impulsa tu operación <span className="opacity-70">→</span>
        </motion.a>

       
        <motion.h1
  initial={{ opacity: 0, y: 18 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6, delay: 0.05 }}
  className="mt-6 heading-display font-extrabold text-ink tracking-tight
             text-[42px] leading-[1.05]
             md:text-[64px] md:leading-[1]
             lg:text-[80px] lg:leading-[0.95]"
>

  <span className="inline md:hidden">
    Bienvenido a{" "}
    <FlipWords
      words={["Zentra Group", "Zentra GPS", "Zentra Sistemas"]}
    />
  </span>

 
  <span className="hidden md:block">
    Bienvenido a
  </span>
  <span className="hidden md:block">
    <FlipWords
      words={["Zentra Group", "Zentra GPS", "Zentra Sistemas"]}
    />
  </span>
</motion.h1>


        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-4 mx-auto max-w-2xl text-[17px] text-ink-muted"
        >
          Automatiza hoy. Gestiona mejor. Controla siempre — da el siguiente paso.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-8 flex items-center justify-center gap-3"
        >
          <a
            href="#nosotros"
            className="btn-brand inline-flex items-center gap-2 rounded-full px-5 py-3 text-[15px] font-medium"
          >
            Conócenos →
          </a>
         
        </motion.div>
      </div>
    </section>
  );
}
